



























export default

	props:
		tableHeading: Array
		tableData: Array
		traceData: Object
		full:
			type: Boolean
			default: false
		caption:
			type: String
			default: ''
		copy: String
		regionClick:
			type: Boolean
			default: false
		contentMap: Object

	methods:
		onClick: (label) -> @$emit 'clicked', label

